import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 20px;
  background-color: #f5f5f5;
`;

export const AccordionContainer = styled.div`
  margin-bottom: 20px;
`;

export const HotelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 1px;

  &:hover {
    background-color: #e9ecef;
  }
`;

export const HotelName = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;

  .icon {
    margin-right: 12px;
    font-size: 1.2rem;
  }
`;

export const MetaInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #6c757d;

  .published-badge {
    display: inline-flex;
    align-items: center;
    background-color: #28a745;
    color: white;
    font-size: 0.75rem;
    padding: 2px 8px;
    border-radius: 12px;
    margin-left: 10px;

    svg {
      margin-right: 4px;
    }
  }
`;

export const AccordionContent = styled.div`
  padding: 16px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin-bottom: 8px;
`;

export const FilterModal = styled.div<{ show: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ show }) => (show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
`;
